export default __webpack_public_path__ + "static/big_logo-90e154f7648796003527b1a509b101bc.svg";